import {createSelector} from '@ngrx/store';
import {selectCaseState} from './common-case.selector';

export const selectCallCardInformations = createSelector(
  selectCaseState,
  (state) => state.case.callCardInformations
);

